export const INVOICE_TYPE_CARRIER = "Carrier"
export const INVOICE_TYPE_SUPPLIER = "Supplier"
export const INVOICE_TYPE_FTL_CARRIER= "FTL /LTL"

export const INVOICE_TYPE_CUSTOMER_INVOICE = "Customer Invoice"

export const MARK_AS_PAID_DIALOG_TITLE = "Mark as Paid"
export const NO_PAYMENT_INFO_DIALOG_MESSAGE = "No payment information attached. Do you want to still mark this as Paid?"

// an invoice only counts as having payment information when all three pieces are present -- this is
// the same condition the invoice tables use to show the payment info icon
export const hasPaymentInfo = (invoice) =>
    !!(invoice && invoice.referenceId && invoice.paymentDate && invoice.bankAccount?.accountNumber)
